var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.store.data
           && _vm.store.response
           && _vm.store.response.links
            && _vm.store.response.links.next
            )?_c('div',{staticClass:"list-row",style:({top:Math.max(_vm.scrollY+_vm.itemHeight*_vm.maxElementRender,((_vm.store.data.length+5)*_vm.itemHeight))+'px'})},[_c('v-card',{staticClass:"pagination-summary"},[(_vm.store.response
           && _vm.store.response.links
            && _vm.store.response.links.next)?_c('div',[_vm._v(" Loading ")]):_vm._e()])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }